// The first-run walkthrough: whether it is showing, and whether it has been seen.
//
// Seen once per phone. It replaces the chassis's two-card Onboarding, so a
// phone that already dismissed that one (`onboarding.v1`) is not shown this
// one unasked — Kit's "Show the intro" is how anyone sees it again.
import { ref } from 'vue';
import { prefs } from '../core/storage.js';

const KEY = 'firstRun.v1';

export const firstRunOpen = ref(false);

/** On launch: open for a phone that has never finished either walkthrough. */
export function openFirstRunIfNew() {
  firstRunOpen.value = prefs[KEY] !== true && prefs['onboarding.v1'] !== true;
}

export function showFirstRun() {
  firstRunOpen.value = true;
}

export function closeFirstRun() {
  prefs[KEY] = true;
  firstRunOpen.value = false;
}
